import Vue from 'vue';
import App from './App.vue';
import router from './router';
import store from './store';
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import locale from 'element-ui/lib/locale';
import enLocale from 'element-ui/lib/locale/lang/en';
import zhLocale from 'element-ui/lib/locale/lang/zh-CN';
import viLocale from 'element-ui/lib/locale/lang/vi';
import { getCurrentLang } from '@/utils/i18nHelper';


// 导入翻译管理器
import { initTranslation } from 'dc-translation-manager';
const getTranslationBaseUrl = () => {
  // 方式1: 从环境变量获取
  if (process.env.VUE_APP_TRANSLATION_BASE_URL) {
    return process.env.VUE_APP_TRANSLATION_BASE_URL;
  }
  // 方式2: 根据当前域名自动判断（作为兜底）
  const { hostname } = window.location;
  const isDev = hostname.toLowerCase().indexOf('test') > -1 || hostname.toLowerCase().indexOf('192.168.11.3') > -1;
  if (isDev) {
    return 'https://cwork-web-test.xgjktech.com.cn';
  }
  return location.origin;
};

initTranslation({
  baseUrl: getTranslationBaseUrl()
});
// --------导入翻译管理器结束


// 设置语言
const lang = getCurrentLang();
const messages = {
  'en': enLocale,
  'zh': zhLocale,
  'vi': viLocale,
};

// 设置 Element 的语言
locale.use(messages[lang] || zhLocale);

// 注册 Element UI
Vue.use(ElementUI, {
  locale: messages[lang] || zhLocale
});

Vue.component('VueMarkdown', () => {
  // return import(/* webpackChunkName: "VueMarkdown" */ '@/utils/Markdown.vue').then(r => r.default);
  return import(/* webpackChunkName: "VueMarkdown" */ '@/utils/MarkdownPreview.vue').then(r => r.default);
});

Vue.config.productionTip = false;

// 最后创建 Vue 实例
const app = new Vue({
  router,
  store,
  render: h => h(App),
  created() {
    // 在根实例中监听语言变化
    this.$on('languageChanged', (newLang) => {
      locale.use(messages[newLang] || zhLocale);
    });
  }
}).$mount('#app');

export default app;
